var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconUploadsong(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48.366,
    height: 55.222,
    viewBox: "0 0 48.366 55.222",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1067",
    "data-name": "Rectangle 1067",
    width: 48.366,
    height: 55.222,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3523",
    "data-name": "Group 3523",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3522",
    "data-name": "Group 3522",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2860",
    "data-name": "Path 2860",
    d: "M25.464,0A6.771,6.771,0,0,1,28.72,1.99q5.439,5.491,10.927,10.932a5.489,5.489,0,0,1,1.8,4.377c-.034.591.007,1.185-.01,1.777a1.76,1.76,0,0,1-3.514-.022,11.882,11.882,0,0,1,0-1.238c.034-.439-.149-.55-.562-.548-2.693.014-5.386,0-8.079.012a4.775,4.775,0,0,1-2.376-.587,4.973,4.973,0,0,1-2.773-4.536c-.027-2.675-.02-5.35,0-8.024.005-.531-.168-.659-.675-.657-5.924.016-11.849.009-17.773.011-1.527,0-2.172.641-2.172,2.16q0,21.92,0,43.84c0,1.558.634,2.189,2.2,2.189q6.625,0,13.249,0a1.738,1.738,0,0,1,1.773,2.111,1.7,1.7,0,0,1-1.67,1.4c-4.775.006-9.551.029-14.326-.01A5.15,5.15,0,0,1,0,50.425c-.008-.287,0-.574,0-.862Q0,27.67,0,5.777C0,2.586,1.2.952,4.24,0Zm2.192,6.2c0,1.847-.006,3.675,0,5.5a1.824,1.824,0,0,0,2.064,2.049c1.7.007,3.408,0,5.113,0,.13,0,.287.067.35-.026L27.656,6.2",
    transform: "translate(0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2861",
    "data-name": "Path 2861",
    d: "M119.764,182.768a15.564,15.564,0,1,1,15.424,15.609,15.612,15.612,0,0,1-15.424-15.609m27.57.041a12.005,12.005,0,1,0-12.014,11.983,11.979,11.979,0,0,0,12.014-11.983",
    transform: "translate(-102.526 -143.155)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2862",
    "data-name": "Path 2862",
    d: "M188.275,221.343v.907q0,4.144,0,8.289a1.763,1.763,0,1,1-3.52-.008q0-4.306,0-8.612v-.661a8.7,8.7,0,0,0-1.221,1.128c-.289.269-.554.562-.842.832a1.8,1.8,0,1,1-2.538-2.536c1.485-1.509,2.99-3,4.487-4.5.2-.2.4-.413.614-.6a1.757,1.757,0,0,1,2.486-.023q2.66,2.59,5.249,5.254a1.781,1.781,0,0,1-.045,2.485,1.827,1.827,0,0,1-2.491.021c-.362-.32-.7-.672-1.034-1.021s-.651-.71-.975-1.065l-.168.11",
    transform: "translate(-153.724 -184.104)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUploadsong);
export default __webpack_public_path__ + "static/media/icon_uploadsong.033c2b6fb3aeab626a531dc5ff7bf55c.svg";
export { ForwardRef as ReactComponent };